"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "ActivityAPI", {
  enumerable: true,
  get: function get() {
    return _activity["default"];
  }
});
_Object$defineProperty(exports, "AdminAPI", {
  enumerable: true,
  get: function get() {
    return _admin["default"];
  }
});
_Object$defineProperty(exports, "AssetAPI", {
  enumerable: true,
  get: function get() {
    return _asset["default"];
  }
});
_Object$defineProperty(exports, "AttributeAPI", {
  enumerable: true,
  get: function get() {
    return _attribute["default"];
  }
});
_Object$defineProperty(exports, "BudgetAPI", {
  enumerable: true,
  get: function get() {
    return _budget["default"];
  }
});
_Object$defineProperty(exports, "ClientAPI", {
  enumerable: true,
  get: function get() {
    return _client["default"];
  }
});
_Object$defineProperty(exports, "CodeSystemAPI", {
  enumerable: true,
  get: function get() {
    return _codesystem["default"];
  }
});
_Object$defineProperty(exports, "CommentAPI", {
  enumerable: true,
  get: function get() {
    return _comment["default"];
  }
});
_Object$defineProperty(exports, "CompanyAPI", {
  enumerable: true,
  get: function get() {
    return _company["default"];
  }
});
_Object$defineProperty(exports, "ConfigurationAPI", {
  enumerable: true,
  get: function get() {
    return _configuration["default"];
  }
});
_Object$defineProperty(exports, "ContactAPI", {
  enumerable: true,
  get: function get() {
    return _contact["default"];
  }
});
_Object$defineProperty(exports, "CredentialManagerAPI", {
  enumerable: true,
  get: function get() {
    return _credentialManager["default"];
  }
});
_Object$defineProperty(exports, "DeviceAPI", {
  enumerable: true,
  get: function get() {
    return _device["default"];
  }
});
_Object$defineProperty(exports, "DocumentAPI", {
  enumerable: true,
  get: function get() {
    return _document["default"];
  }
});
_Object$defineProperty(exports, "EventAPI", {
  enumerable: true,
  get: function get() {
    return _event["default"];
  }
});
_Object$defineProperty(exports, "ExpenseAPI", {
  enumerable: true,
  get: function get() {
    return _expense["default"];
  }
});
_Object$defineProperty(exports, "FavoriteAPI", {
  enumerable: true,
  get: function get() {
    return _favorite["default"];
  }
});
_Object$defineProperty(exports, "FileAPI", {
  enumerable: true,
  get: function get() {
    return _file["default"];
  }
});
_Object$defineProperty(exports, "HistoryAPI", {
  enumerable: true,
  get: function get() {
    return _history["default"];
  }
});
_Object$defineProperty(exports, "LineitemAPI", {
  enumerable: true,
  get: function get() {
    return _lineItem["default"];
  }
});
_Object$defineProperty(exports, "LoginAPI", {
  enumerable: true,
  get: function get() {
    return _login["default"];
  }
});
_Object$defineProperty(exports, "NotificationAPI", {
  enumerable: true,
  get: function get() {
    return _notification["default"];
  }
});
_Object$defineProperty(exports, "PermissionAPI", {
  enumerable: true,
  get: function get() {
    return _permission["default"];
  }
});
_Object$defineProperty(exports, "PreferenceAPI", {
  enumerable: true,
  get: function get() {
    return _preference["default"];
  }
});
_Object$defineProperty(exports, "ProjectAPI", {
  enumerable: true,
  get: function get() {
    return _project["default"];
  }
});
_Object$defineProperty(exports, "PropertyAPI", {
  enumerable: true,
  get: function get() {
    return _property["default"];
  }
});
_Object$defineProperty(exports, "RelatedAPI", {
  enumerable: true,
  get: function get() {
    return _related["default"];
  }
});
_Object$defineProperty(exports, "ReportAPI", {
  enumerable: true,
  get: function get() {
    return _report["default"];
  }
});
_Object$defineProperty(exports, "RfiAPI", {
  enumerable: true,
  get: function get() {
    return _rfi["default"];
  }
});
_Object$defineProperty(exports, "RfpAPI", {
  enumerable: true,
  get: function get() {
    return _rfp["default"];
  }
});
_Object$defineProperty(exports, "RoleAPI", {
  enumerable: true,
  get: function get() {
    return _role["default"];
  }
});
_Object$defineProperty(exports, "RsvpAPI", {
  enumerable: true,
  get: function get() {
    return _rsvp["default"];
  }
});
_Object$defineProperty(exports, "ScheduleAPI", {
  enumerable: true,
  get: function get() {
    return _schedule["default"];
  }
});
_Object$defineProperty(exports, "SearchAPI", {
  enumerable: true,
  get: function get() {
    return _search["default"];
  }
});
_Object$defineProperty(exports, "ServiceAPI", {
  enumerable: true,
  get: function get() {
    return _service["default"];
  }
});
_Object$defineProperty(exports, "SettingAPI", {
  enumerable: true,
  get: function get() {
    return _setting["default"];
  }
});
_Object$defineProperty(exports, "SignupAPI", {
  enumerable: true,
  get: function get() {
    return _signup["default"];
  }
});
_Object$defineProperty(exports, "SopAPI", {
  enumerable: true,
  get: function get() {
    return _sop["default"];
  }
});
_Object$defineProperty(exports, "SpaceAPI", {
  enumerable: true,
  get: function get() {
    return _space["default"];
  }
});
_Object$defineProperty(exports, "SubmittalAPI", {
  enumerable: true,
  get: function get() {
    return _submittal["default"];
  }
});
_Object$defineProperty(exports, "SubscriptionAPI", {
  enumerable: true,
  get: function get() {
    return _subscription["default"];
  }
});
_Object$defineProperty(exports, "SupportAPI", {
  enumerable: true,
  get: function get() {
    return _support["default"];
  }
});
_Object$defineProperty(exports, "TagAPI", {
  enumerable: true,
  get: function get() {
    return _tag["default"];
  }
});
_Object$defineProperty(exports, "TaskAPI", {
  enumerable: true,
  get: function get() {
    return _task["default"];
  }
});
_Object$defineProperty(exports, "TicketAPI", {
  enumerable: true,
  get: function get() {
    return _ticket["default"];
  }
});
_Object$defineProperty(exports, "TimeoffAPI", {
  enumerable: true,
  get: function get() {
    return _timeoff["default"];
  }
});
_Object$defineProperty(exports, "TimesheetAPI", {
  enumerable: true,
  get: function get() {
    return _timesheet["default"];
  }
});
_Object$defineProperty(exports, "TodoAPI", {
  enumerable: true,
  get: function get() {
    return _todo["default"];
  }
});
_Object$defineProperty(exports, "UserAPI", {
  enumerable: true,
  get: function get() {
    return _user["default"];
  }
});
_Object$defineProperty(exports, "UsertenantAPI", {
  enumerable: true,
  get: function get() {
    return _usertenant["default"];
  }
});
_Object$defineProperty(exports, "ValueSetAPI", {
  enumerable: true,
  get: function get() {
    return _valueset["default"];
  }
});
_Object$defineProperty(exports, "WatchAPI", {
  enumerable: true,
  get: function get() {
    return _watch["default"];
  }
});
_Object$defineProperty(exports, "WeatherAPI", {
  enumerable: true,
  get: function get() {
    return _weather["default"];
  }
});
_Object$defineProperty(exports, "WorkflowAPI", {
  enumerable: true,
  get: function get() {
    return _workflow["default"];
  }
});
exports["default"] = void 0;
var _api = _interopRequireDefault(require("./_api"));
var _activity = _interopRequireDefault(require("./activity"));
var _admin = _interopRequireDefault(require("./admin"));
var _asset = _interopRequireDefault(require("./asset"));
var _attribute = _interopRequireDefault(require("./attribute"));
var _budget = _interopRequireDefault(require("./budget"));
var _client = _interopRequireDefault(require("./client"));
var _codesystem = _interopRequireDefault(require("./codesystem"));
var _comment = _interopRequireDefault(require("./comment"));
var _company = _interopRequireDefault(require("./company"));
var _configuration = _interopRequireDefault(require("./configuration"));
var _contact = _interopRequireDefault(require("./contact"));
var _credentialManager = _interopRequireDefault(require("./credentialManager"));
var _device = _interopRequireDefault(require("./device"));
var _document = _interopRequireDefault(require("./document"));
var _event = _interopRequireDefault(require("./event"));
var _expense = _interopRequireDefault(require("./expense"));
var _favorite = _interopRequireDefault(require("./favorite"));
var _file = _interopRequireDefault(require("./file"));
var _history = _interopRequireDefault(require("./history"));
var _lineItem = _interopRequireDefault(require("./lineItem"));
var _login = _interopRequireDefault(require("./login"));
var _notification = _interopRequireDefault(require("./notification"));
var _permission = _interopRequireDefault(require("./permission"));
var _preference = _interopRequireDefault(require("./preference"));
var _project = _interopRequireDefault(require("./project"));
var _property = _interopRequireDefault(require("./property"));
var _report = _interopRequireDefault(require("./report"));
var _rfi = _interopRequireDefault(require("./rfi"));
var _rfp = _interopRequireDefault(require("./rfp"));
var _role = _interopRequireDefault(require("./role"));
var _rsvp = _interopRequireDefault(require("./rsvp"));
var _schedule = _interopRequireDefault(require("./schedule"));
var _search = _interopRequireDefault(require("./search"));
var _service = _interopRequireDefault(require("./service"));
var _setting = _interopRequireDefault(require("./setting"));
var _signup = _interopRequireDefault(require("./signup"));
var _sop = _interopRequireDefault(require("./sop"));
var _space = _interopRequireDefault(require("./space"));
var _submittal = _interopRequireDefault(require("./submittal"));
var _subscription = _interopRequireDefault(require("./subscription"));
var _support = _interopRequireDefault(require("./support"));
var _tag = _interopRequireDefault(require("./tag"));
var _task = _interopRequireDefault(require("./task"));
var _ticket = _interopRequireDefault(require("./ticket"));
var _timeoff = _interopRequireDefault(require("./timeoff"));
var _timesheet = _interopRequireDefault(require("./timesheet"));
var _todo = _interopRequireDefault(require("./todo"));
var _user = _interopRequireDefault(require("./user"));
var _usertenant = _interopRequireDefault(require("./usertenant"));
var _valueset = _interopRequireDefault(require("./valueset"));
var _watch = _interopRequireDefault(require("./watch"));
var _weather = _interopRequireDefault(require("./weather"));
var _workflow = _interopRequireDefault(require("./workflow"));
var _related = _interopRequireDefault(require("./related"));
function cov_1fj4qgc2ts() {
  var path = "/home/node/project/src/index.js";
  var hash = "225ec27639eee096d1a6af6d1c99573470d5d624";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "225ec27639eee096d1a6af6d1c99573470d5d624"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1fj4qgc2ts = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1fj4qgc2ts();
var _default = exports["default"] = _api["default"];